import { Container, FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_ICON } from "@constants/pictures"
import clsx from "clsx"
import Image from "next/image"
import React from "react"
import { BootcampHeading } from "../general/ProgramHeading"

const METHODS = [
  {
    icon: "icon_cost-transformation.svg",
    title: "Cash 100% Upfront",
    subTitle: "Lakukan pembayaran secara lunas setelah memilih program yang kamu inginkan.",
  },
  {
    icon: "icon_frame.svg",
    title: "Cicilan",
    subTitle:
      "Kalau kamu ngerasa berat buat bayar langsung lunas, bisa banget loh dicicil melalui harisenin.com maupun layanan yang tersedia.",
  },
  // {
  //   icon: "icon_frame-2.svg",
  //   title: "Bayar Setelah Kerja",
  //   subTitle:
  //     "Yang penting belajar dulu, bayarnya bisa mulai dilakukan setelah dapat gaji pertama.",
  // },
]

export const BootcampPayments = () => {
  return (
    <div className="bg-[#efefef] sm:py-20 py-10">
      <Container className="relative grid sm:gap-9 gap-6">
        <div className="relative">
          <BootcampHeading
            id="payments"
            title="opsi pembayaran"
            subTitle="Bayar Jadi Mudah & Bisa Dicicil"
          />
        </div>

        <div className="grid sm:grid-cols-2 sm:gap-9 gap-6">
          {METHODS.map((method, idx) => (
            <div
              key={idx}
              className={clsx("bg-white grid rounded-lg h-fit", "sm:p-6 p-4 sm:gap-4 gap-3")}
            >
              <FlexBox
                className={clsx("bg-body-bg p-2 sm:w-[52px] sm:h-[52px] wh-9")}
                justify="center"
                align="center"
              >
                <Image
                  src={`${HARISENIN_PUBLIC_ICON}/${method.icon}`}
                  width={30}
                  height={30}
                  alt={method.title}
                />
              </FlexBox>

              <div className="grid gap-1.5">
                <div className="font-urbanist sm:text-lg text-black-22 font-bold">{method.title}</div>
                <div className="text-secondary-grey sm:text-sm text-xs sm:h-[3em]">{method.subTitle}</div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
